import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PermissionService } from './core/services/permission.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet />',
})
export class App {
  private permissionService = inject(PermissionService);

  constructor() {
    this.permissionService.init();
  }
}
